import { useState } from "react";

import BoletimSection from "../BoletimSection/BoletimSection";

import { MEDIA_URL } from "../../api/Constants";

import Check from "./Check/Check";
import styles from "./DadosPessoais.module.css";
import Dots from "./Dots/Dots";
import InfoTile from "./InfoTile/InfoTile";

function DadosPessoais({ student }) {
	const [showProfilePic, setShowProfilePic] = useState(false);
	const [nameClicks, setNameClicks] = useState(0);

	function nameClickHandler() {
		setNameClicks((curr) => curr + 1);

		if (nameClicks === 4) {
			setShowProfilePic((curr) => !curr);
			setNameClicks(0);
		}
	}

	return (
		<BoletimSection
			title="Dados pessoais"
			icon="person"
			dark={true}
		>
			<div className={styles.container}>
				{showProfilePic && (
					<div className={styles.profilePic}>
						<img
							src={`${MEDIA_URL}${student.ra}_facial.jpg`}
							alt=""
						/>
					</div>
				)}
				<div className={styles.studentContainer}>
					<h2
						className={styles.studentName}
						onClick={nameClickHandler}
					>
						{student.name}
					</h2>
					<div className={styles.infoContainer}>
						<div className={styles.infoColumn}>
							<InfoTile
								label="RA"
								value={student.ra}
							/>
							<InfoTile
								label="Curso"
								value={student.course}
							/>
							<InfoTile
								label="Turma"
								value={student.class}
							/>
							<InfoTile label="Advertência">
								<Dots
									type={"adv"}
									value={student.warning}
									maxValue={3}
								/>
							</InfoTile>
							<InfoTile label="Suspensão">
								<Dots
									type={"susp"}
									value={student.suspension}
									maxValue={3}
								/>
							</InfoTile>
							{student.community && (
								<InfoTile
									label="Comunidade"
									value={student.community}
								/>
							)}
						</div>
						<div className={styles.infoColumn}>
							<InfoTile
								label="Ano"
								value={student.year}
							/>
							<InfoTile
								label="Semestre"
								value={`${student.semester}°`}
							/>
							<InfoTile label="Ambassador">
								<Check checked={student.brand_ambassador} />
							</InfoTile>
							<InfoTile label="Representante de turma">
								<Check checked={student.represent} />
							</InfoTile>
							{student.profile && (
								<InfoTile
									label="Perfil"
									value={student.profile}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</BoletimSection>
	);
}

export default DadosPessoais;
